<template lang="pug">
	.project-versions(v-if="project" :style="{'height': `calc(100% - ${Layout.subHeaderHeight}px)`, 'top': `${Layout.subHeaderHeight}px`, 'left': `${Layout.getProjectsPlaneWidth()}px`}")
		.p-3.project-settings-header(v-if="project")
			.caption
				span(v-if="")
					.ready(v-if="project.type === 'playable'") Playable
					.ready(v-if="project.type === 'banner'") Banner
					.ready(v-if="project.type === 'end-card'") End Card
				span {{project.title}}
				ProjectActions
				span(v-if="User.currentUser.Tags['admin'] && project.type === 'playable'")
					.in-development(v-if="!project.Tags['released']") Separated js files
					.ready(v-if="project.Tags['released']") Combined js files
				VersionsSearchBar
		.project-settings-wrapper(v-bar :style="{'height': `calc(100% - ${Layout.headerHeight + Layout.subHeaderHeight}px - 37px)`}")
			.project-settings-inner
				.project-version-list(v-if="Project.isSelectedProjectLoaded()")
					.project-version(v-if="!version.Tags['hidden'] || isShowHiddenVersions" v-for="version in versions" :class="{base: version.Tags.base, custom: !version.Tags.base}")
						.project-version-title-wrapper(:class="{selected: Version.SelectedVersion && Version.SelectedVersion.id === version.id}" @click="Version.selectVersion(version.id)")
							.project-version-title
								i.fa.fa-lock(v-if="version.Tags.base && (project.type === 'playable' || project.type === 'end-card')")
								span {{getVersionTitle(version)}}
							.project-version-online(v-if="Layout.isFeatureEnabled('online-users', 'online-users-version-plane')")
								OnlineUsersLocal(:filter="getFilterForOnlineUsers(version.id)" max-count="5")
						.project-version-edit-wrapper(:class="{selected: Version.SelectedVersion && Version.SelectedVersion.id === version.id}" @click="editVersionSettings(version)")
							.project-version-edit
								i.fa.fa-gear
				.archived-settings(v-if="Settings.isHiddenVersions() && !isShowHiddenVersions")
					button.btn.btn-outline-secondary(@click="isShowHiddenVersions = true")
						.archived-settings-title Show hidden versions
				.archived-settings(v-if="Settings.isHiddenVersions() && isShowHiddenVersions")
					button.btn.btn-outline-secondary(@click="isShowHiddenVersions = false")
						.archived-settings-title Hide hidden versions
				.add-version(v-if="project.type === 'banner' || project.type === 'end-card'")
					.version-add-icon(v-on:click="addVersion()" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Create version'}")
						i.fa.fa-plus

</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { User } 			from './../../services/User'
	import { Project } 			from './../../services/Project'
	import { Version } 			from './../../services/Version'
	import { Settings } 		from './../../services/Settings'
	import { Layout } 			from './../../services/Layout'

	import ProjectActions 		from './../Project/ProjectActions'
	import VersionsSearchBar 	from './../Project/VersionsSearchBar'
	import OnlineUsersLocal		from './../Header/OnlineUsersLocal';

	export default {
		name: 'ProjectVersions',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Layout Page Changed", //Меняется ширина projects plane
				"Selected Publisher Changed",
				"Selected Version Changed",
				"Project Fully Loaded",
				"Versions Filter Changed",
				"Current User Feature Changed",
				"Users Online Status Changed",
				"User Online Status Changed",
				"User Online Status Added",
				"User Online Status Removed",
				"Selected Project Renamed",
				"Selected Project Tags Changed",
				"Selected Project Version Loaded",
				"Version Renamed",
				"Version Hided",
				"Version Showed",
				"Version Deleted"
			]
		},
		components: {
			ProjectActions,
			VersionsSearchBar,
			OnlineUsersLocal
		},
		data() {

			this.User = User;
			this.Project = Project;
			this.Version = Version;
			this.Settings = Settings;

			this.project = null;
			this.versions = [];

			return {
				showed: true,
				isShowHiddenVersions: false
			};

		},
		methods: {
			collectData() {

				this.project = Project.SelectedProject;
				this.versions = [];

				if (this.project) {

					let versions = _.values(Version.VersionsByProject[this.project.id]);

					if (this.project.type === 'playable') {

						let baseVersions = _.sortBy(_.filter(versions, v => v.Tags.base), "create_date");
						let customVersions = _.sortBy(_.filter(versions, v => v.Tags.custom), "create_date");
						versions = [...baseVersions, ...customVersions];

					} else if (this.project.type === 'banner') {

						versions = _.sortBy(versions, "create_date");

					}

					if (Layout.versionsFilter) versions = _.filter(versions, v => v.title.toLowerCase().indexOf(Layout.versionsFilter.toLowerCase()) > -1 || v.codename.toLowerCase().indexOf(Layout.versionsFilter.toLowerCase()) > -1);

					this.versions = versions;

				}

			},
			editVersionSettings(version) {

				Broadcast.call("Show VersionSettings", [version.id]);

				Broadcast.call("Pseudo Modal Hide", ['project-settings-options-dropdown']);

			},
			getFilterForOnlineUsers(versionId) {

				return userData => User.getLastActiveVersionData(userData).versionId === versionId;

			},
			addVersion() {

				if (this.project.type === 'banner') {
					Broadcast.call("Show ProjectVersionCreateBanner");
				} else {
					Server.sendToSocket({
						CreateVersion: {
							projectId: Project.SelectedProject.id
						}
					});
				}

			},
			getVersionTitle(version) {

				if (this.project.type === 'playable') {

					return version.codename || version.title;

				} else {

					return version.title || version.codename;

				}

			}
		}
	}
</script>

<style lang="sass">

	.project-versions
		width: 250px
		height: 100%
		background-color: #3a4149
		border-right: 1px solid #23282c
		color: #f3f4f5
		text-align: left
		position: absolute
		left: 0
		top: 0
		transition: left 0.2s ease-in-out

		.project-settings-header
			border-bottom: 1px solid #23282c

		.caption
			font-weight: 500
			cursor: default

			.in-development
				font-size: 0.775rem
				color: #f86c6b

			.ready
				font-size: 0.775rem
				color: #4dbd74

		.project-settings-wrapper
			overflow-x: hidden
			overflow-y: auto

			&::-webkit-scrollbar
				position: fixed
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			&::-webkit-scrollbar-track
				background-color: rgba(0, 0, 0, 0.2)

			&::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(0, 0, 0, 0.2)
				background-clip: content-box
				border-color: transparent
				border-radius: 5px

		.project-settings
			height: 48px
			display: flex
			align-items: center
			justify-content: left
			border-bottom: 1px solid #23282c
			cursor: pointer

			&:hover
				background-color: #2f353a

			&:active
				background-color: #f3f4f5
				color: #2f353a

			&.selected
				background-color: #20a8d8

		.archived-settings
			height: 56px
			display: flex
			justify-content: center
			white-space: nowrap
			align-content: center
			align-items: center

			button.btn.btn-outline-secondary
				height: 30px
				background-color: #3a4149
				color: #6d7a88
				border-color: #58636e
				padding: 0.25rem 0.4rem

				&:active
					color: #fff !important
					background-color: #656f7a !important

				&:hover
					background-color: #303539
					color: #fff

				&:focus
					box-shadow: none

				.archived-settings-title
					font-size: 12px

		.project-version
			height: 48px
			display: flex
			justify-content: space-between
			border-bottom: 1px solid #23282c
			cursor: pointer

			&:hover
				background-color: #2f353a

			&:active
				background-color: #f3f4f5
				color: #2f353a

			.project-version-title-wrapper
				display: flex
				flex-direction: row
				align-items: center
				width: 85%
				white-space: nowrap

				&.selected
					background-color: #20a8d8

				.project-version-title
					padding: 0 1rem

					i
						margin-right: 10px

				.project-version-online
					height: 15px
					width: 100%

					.c-avatar-status
						display: none

				.project-version-title-hidden
					color: #8e8e8e
					padding: 0 1rem

			.project-version-edit-wrapper
				display: flex
				flex-direction: row
				justify-content: center
				align-items: center
				width: 20%

				&.selected
					background-color: #20a8d8

				&:hover
					color: #20a8d8

				&.selected:hover
					color: #23282c

				.project-version-edit
					display: flex
					visibility: hidden
					padding: 0 1rem 0 1rem

		.project-version:hover
			.project-version-edit
				visibility: visible

		.add-version
			display: flex
			justify-content: center
			align-items: center
			height: 50px

			.version-add-icon
				color: #f3f4f5
				width: 28px
				cursor: pointer

				&:hover
					color: #20a8d8

</style>

